module.exports = new __parcel__URL__("brush.628d2e64.svg").toString();